import api from "../axiosInstance";

// UI Permissions (public read for authenticated users)
export async function getUiPermissionsMap() {
  const resp = await api.get("/api/admin/management/ui-permissions");
  return resp.data;
}

export async function getMyGrantedComponents() {
  const resp = await api.get("/api/admin/management/ui-permissions/me");
  return resp.data;
}

// UI Permissions Admin (management)
export async function listUiComponents() {
  const resp = await api.get("/api/admin/management/ui-permissions/components");
  return resp.data;
}

export async function createUiComponent(payload) {
  // payload: { key, group, description }
  const resp = await api.post("/api/admin/management/ui-permissions/components", payload);
  return resp.data;
}

export async function updateUiComponent(id, payload) {
  // payload: { active }
  const resp = await api.put(`/api/admin/management/ui-permissions/components/${id}`, payload);
  return resp.data;
}

export async function getComponentRoles(id) {
  const resp = await api.get(`/api/admin/management/ui-permissions/components/${id}/roles`);
  return resp.data;
}

export async function replaceComponentRoles(id, payload) {
  // payload: { allowedRoles: string[] }
  const resp = await api.put(`/api/admin/management/ui-permissions/components/${id}/roles`, payload);
  return resp.data;
}

export async function patchComponentRoles(id, payload) {
  // payload: { add?: string[], remove?: string[] }
  const resp = await api.patch(`/api/admin/management/ui-permissions/components/${id}/roles`, payload);
  return resp.data;
}


